import { render, staticRenderFns } from "./DeleteOrderBoxModal.vue?vue&type=template&id=5065e05a&scoped=true&"
import script from "./DeleteOrderBoxModal.vue?vue&type=script&lang=js&"
export * from "./DeleteOrderBoxModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteOrderBoxModal.vue?vue&type=style&index=0&id=5065e05a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5065e05a",
  null
  
)

export default component.exports